export const CONTINENTS = [
  "Europe",
  "Amérique du Nord",
  "Amérique du Sud",
  "Afrique",
  "Asie",
  "Moyen-Orient",
  "Océanie",
];

export const GENRES = [
  "Pop",
  "Jazz",
  "Rap",
  "Classique",
  "Electro",
  "Rock",
  "Soul",
  "Gospel",
  "Musique du monde",
];

export const EVENT_TYPES = [
  "Mariage",
  "Anniversaire",
  "Gala privé",
  "Événement d'entreprise",
  "Soirée privée",
  "Concert privé",
  "Expérience VIP",
];

export const BUDGETS = [
  { label: "Tous les budgets", value: "all" },
  { label: "Moins de 15 000 €", value: "0-15000" },
  { label: "15 000 € - 30 000 €", value: "15000-30000" },
  { label: "30 000 € - 50 000 €", value: "30000-50000" },
  { label: "Plus de 50 000 €", value: "50000+" },
];

export const STATUS_META = {
  en_attente: { label: "En attente", color: "#D4AF37", bg: "rgba(212,175,55,0.15)" },
  valide: { label: "Validé par l'artiste", color: "#2EE59D", bg: "rgba(46,229,157,0.15)" },
  devis_envoye: { label: "Devis envoyé", color: "#3B82F6", bg: "rgba(59,130,246,0.15)" },
  confirme: { label: "Confirmé", color: "#2EE59D", bg: "rgba(46,229,157,0.2)" },
  refuse: { label: "Refusé", color: "#FF4D4D", bg: "rgba(255,77,77,0.15)" },
};
